export default "__VITE_ASSET__u_abVVp7__"